<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('vo2max.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
            </div>
            <div id="chart-box"></div>
            <div class="legend-box">
                <div class="legend-bar1 legend-bar"></div>
                <div class="legend-bar2 legend-bar"></div>
                <div class="legend-bar3 legend-bar"></div>
                <div class="legend-bar4 legend-bar"></div>
                <div class="legend-bar5 legend-bar"></div>
                <div class="legend-bar6 legend-bar"></div>
                <div class="legend-text1 legend-text"> {{$t('vo2max.level0')}}</div>
                <div class="legend-text2 legend-text"> {{$t('vo2max.level1')}}</div>
                <div class="legend-text3 legend-text"> {{$t('vo2max.level2')}}</div>
                <div class="legend-text4 legend-text"> {{$t('vo2max.level3')}}</div>
                <div class="legend-text5 legend-text"> {{$t('vo2max.level4')}}</div>
                <div class="legend-text6 legend-text"> {{$t('vo2max.level5')}}</div>
            </div>
        </div>
        <div class="math-box">
            <van-row>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.maxData ? mathData.maxData : '--'}}</div>
                        <div class="math-text">{{$t('vo2max.math0')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.minData ? mathData.minData : '--'}}</div>
                        <div class="math-text">{{$t('vo2max.math1')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.avgData ? mathData.avgData : '--'}}</div>
                        <div class="math-text">{{$t('vo2max.math2')}}</div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="desc-box">
            <div class="desc-title">{{$t('vo2max.descTitle')}}</div>
            <div class="desc-info">
                {{$t('vo2max.desc')}}
            </div>
            <div class="vo2max-box">
                <div class="vo2max-title">{{$t('vo2max.age')}} {{this.age}}</div>
                <div class="light-item">
                    <div class="item-key">{{$t('vo2max.level0')}}：</div>
                    <div class="item-value">&lt;{{mutableList[0]}}</div>
                </div>
                <div class="dark-item">
                    <div class="item-key">{{$t('vo2max.level1')}}：</div>
                    <div class="item-value">{{mutableList[0]}}-{{mutableList[1]}}</div>
                </div>
                <div class="light-item">
                    <div class="item-key">{{$t('vo2max.level2')}}：</div>
                    <div class="item-value">{{mutableList[1]}}-{{mutableList[2]}}</div>
                </div>
                <div class="dark-item">
                    <div class="item-key">{{$t('vo2max.level3')}}：</div>
                    <div class="item-value">{{mutableList[2]}}-{{mutableList[3]}}</div>
                </div>
                <div class="light-item">
                    <div class="item-key">{{$t('vo2max.level4')}}：</div>
                    <div class="item-value">{{mutableList[3]}}-{{mutableList[4]}}</div>
                </div>
                <div class="dark-item">
                    <div class="item-key">{{$t('vo2max.level5')}}：</div>
                    <div class="item-value">≥{{mutableList[4]}}</div>
                </div>
            </div>
            <div class="desc-last"></div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {
        getToday,
        getNWeekFirstDay,
        getNWeekLastDay,
        getMonthStartDay,
        getMonthEndDay,
        GetDateStr, SwitchTime24,
        changeDate,
        changeMonthDate,
        GetYear
    } from "../../utils/dateUtils";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'vo2max',
        data() {
            return {
                ratio: 1,
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                activeTime: 0,
                timeUnit: '',
                time: '',
                startDate: '',
                endDate: '',
                wNum: 0,
                mNum: 0,
                showTimeBox: false,
                info: {},
                mathData: {},
                myChart: null,
                showLeftOpacity: 0,
                showRightOpacity: 1,
                mutableList: ['', '', '', '', ''],
                age: '',
                watchType: '',
            }
        },
        watch: {
            showTimeBox: {
                handler(newVal, olVal) {
                    if (newVal) {
                        setTimeout(() => {
                            document.addEventListener('click', this.checkClick);
                        }, 0);
                    } else {
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            }
        },
        mounted() {
            if (this.$route.query.watchType) {
                this.watchType = this.$route.query.watchType
            }
            this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
            this.timeUnit = this.$t('vo2max.time0');
            this.startDate = getNWeekFirstDay(this.wNum);
            this.endDate = getNWeekLastDay(this.wNum);
            this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            heckClick(event) {
                let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
                if (!dom.contains(event.target)) {
                    // 不在菜单范围，隐藏即可
                    if (this.showTimeBox) {
                        this.showTimeBox = false;
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            },
            checkOpacity() {
                if (this.activeTime == 0 && this.wNum >= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 1 && this.mNum >= 0) {
                    this.showRightOpacity = 1
                } else {
                    this.showRightOpacity = 0
                }
                if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else {
                    this.showLeftOpacity = 0
                }
            },
            timeLeft() {
                if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                    this.wNum--;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                    this.mNum--;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            timeRight() {
                if (this.activeTime == 0 && this.wNum < 0) {
                    this.wNum++;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.mNum < 0) {
                    this.mNum++;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            changeTimeType(num, unit) {
                this.activeTime = num;
                this.timeUnit = unit;
                this.showTimeBox = false;
                if (this.activeTime == 0) {
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 1) {
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            getData() {
                this.checkOpacity()
                this.$api.status.queryVo2max({
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.info = res.info;
                        this.age = this.info.age;
                        this.mutableList = this.getMutable(this.info.age, this.info.sex);
                        this.mathData.maxData = res.info.math.max;
                        this.mathData.avgData = res.info.math.avg;
                        this.mathData.minData = res.info.math.min;
                        this.info.dateArr = [];
                        this.info.dataArr = [];
                        for (let i = 0; i < this.info.data.length; i++) {
                            this.info.dateArr.push(this.info.data[i].date);
                            let color;
                            let data = this.info.data[i].vo2max;
                            if (data > 0) {
                                color = this.getLevelColor(data)
                            } else {
                                data = null
                            }
                            let style = {
                                value: data,
                                itemStyle: {
                                    color: color
                                },
                                emphasis: {
                                    itemStyle: {
                                        borderColor: color,
                                        borderWidth: 1.5 * this.ratio,
                                        color: 'transparent'
                                    }
                                }
                            }
                            this.info.dataArr.push(style);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            },
            getLevelColor(level) {
                let color;
                if (level < this.mutableList[0]) {
                    color = getSkin('--chart-color-3');
                } else if (level < this.mutableList[1]) {
                    color = getSkin('--chart-color-15');
                } else if (level < this.mutableList[2]) {
                    color = getSkin('--chart-color-5');
                } else if (level < this.mutableList[3]) {
                    color = getSkin('--chart-color-1');
                } else if (level < this.mutableList[4]) {
                    color = getSkin('--chart-color-8');
                } else {
                    color = getSkin('--chart-color-10');
                }
                return color;
            },
            drawChart() {
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }
                if (!this.mathData.avgData) {
                    this.myChart.setOption({
                        title: {
                            text: this.$t('noData'),
                            x: 'center',
                            y: 76 * this.ratio,
                            textStyle: {
                                fontFamily: 'SF',
                                fontSize: 12 * this.ratio,
                                fontWeight: 'normal',
                                color: getSkin('--text-color-2')
                            }
                        },
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.info.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: [0, 0, 0],
                                type: 'bar',
                                symbol: 'none',
                                smooth: false,
                                barWidth: 10,
                                lineStyle: {
                                    width: 3
                                }
                            }
                        ]
                    }, true);
                } else {
                    let _this = this;
                    this.myChart.setOption({
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            backgroundColor: getSkin('--bg-color-2'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0] - size.contentSize[0] / 2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth) {
                                    x = cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.value ? item.value : 0;
                                if (value == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + changeDate(item.axisValue) + '</div>'
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span></div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                formatter: function (value) {
                                    return changeDate(value)
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.info.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: this.info.dataArr,
                                type: 'scatter',
                                symbolSize: 6 * this.ratio,
                            }
                        ]
                    }, true);
                }
            },
            getMutable(age, gender) {
                let zone1, zone2, zone3, zone4, zone5;
                if (age >= 20 && age <= 29) {
                    if (gender == 1) {
                        if (this.watchType == 'TA3000') {
                            zone1 = 36;
                            zone2 = 41;
                            zone3 = 50;
                            zone4 = 57;
                            zone5 = 65;
                        } else {
                            zone1 = 32.1;
                            zone2 = 40.1;
                            zone3 = 48;
                            zone4 = 55.2;
                            zone5 = 66.3;
                        }
                    } else {
                        if (this.watchType == 'TA3000') {
                            zone1 = 29;
                            zone2 = 35;
                            zone3 = 43;
                            zone4 = 50;
                            zone5 = 57;
                        } else {
                            zone1 = 23.9;
                            zone2 = 30.5;
                            zone3 = 37.6;
                            zone4 = 44.7;
                            zone5 = 56;
                        }
                    }
                } else if (age >= 30 && age <= 39) {
                    if (gender == 1) {
                        if (this.watchType == 'TA3000') {
                            zone1 = 33;
                            zone2 = 38;
                            zone3 = 47;
                            zone4 = 54;
                            zone5 = 62;
                        } else {
                            zone1 = 30.2;
                            zone2 = 35.9;
                            zone3 = 42.4;
                            zone4 = 49.2;
                            zone5 = 59.8;
                        }
                    } else {
                        if (this.watchType == 'TA3000') {
                            zone1 = 28;
                            zone2 = 33;
                            zone3 = 41;
                            zone4 = 48;
                            zone5 = 55;
                        } else {
                            zone1 = 20.9;
                            zone2 = 25.3;
                            zone3 = 30.2;
                            zone4 = 36.1;
                            zone5 = 45.8;
                        }
                    }
                } else if (age >= 40 && age <= 49) {
                    if (gender == 1) {
                        if (this.watchType == 'TA3000') {
                            zone1 = 30;
                            zone2 = 36;
                            zone3 = 44;
                            zone4 = 51;
                            zone5 = 59;
                        } else {
                            zone1 = 26.8;
                            zone2 = 31.9;
                            zone3 = 37.8;
                            zone4 = 45;
                            zone5 = 55.6;
                        }
                    } else {
                        if (this.watchType == 'TA3000') {
                            zone1 = 26;
                            zone2 = 31;
                            zone3 = 39;
                            zone4 = 46;
                            zone5 = 53;
                        } else {
                            zone1 = 18.8;
                            zone2 = 22.1;
                            zone3 = 26.7;
                            zone4 = 32.4;
                            zone5 = 41.7;
                        }
                    }
                } else if (age >= 50 && age <= 59) {
                    if (gender == 1) {
                        if (this.watchType == 'TA3000') {
                            zone1 = 26;
                            zone2 = 31;
                            zone3 = 39;
                            zone4 = 46;
                            zone5 = 53;
                        } else {
                            zone1 = 22.8;
                            zone2 = 27.1;
                            zone3 = 32.6;
                            zone4 = 39.7;
                            zone5 = 50.7;
                        }
                    } else {
                        if (this.watchType == 'TA3000') {
                            zone1 = 23;
                            zone2 = 28;
                            zone3 = 35;
                            zone4 = 42;
                            zone5 = 49;
                        } else {
                            zone1 = 17.3;
                            zone2 = 19.9;
                            zone3 = 23.4;
                            zone4 = 27.6;
                            zone5 = 35.9;
                        }
                    }
                } else if (age >= 60 && age <= 69) {
                    if (gender == 1) {
                        if (this.watchType == 'TA3000') {
                            zone1 = 22;
                            zone2 = 28;
                            zone3 = 34;
                            zone4 = 40;
                            zone5 = 46;
                        } else {
                            zone1 = 19.8;
                            zone2 = 23.7;
                            zone3 = 28.2;
                            zone4 = 34.5;
                            zone5 = 43;
                        }
                    } else {
                        if (this.watchType == 'TA3000') {
                            zone1 = 21;
                            zone2 = 26;
                            zone3 = 31;
                            zone4 = 38;
                            zone5 = 44;
                        } else {
                            zone1 = 14.6;
                            zone2 = 17.2;
                            zone3 = 20;
                            zone4 = 23.8;
                            zone5 = 29.4;
                        }
                    }
                } else if (age >= 70 && age <= 79) {
                    if (gender == 1) {
                        if (this.watchType == 'TA3000') {
                            zone1 = 21;
                            zone2 = 26;
                            zone3 = 31;
                            zone4 = 38;
                            zone5 = 44;
                        } else {
                            zone1 = 17.1;
                            zone2 = 20.4;
                            zone3 = 24.4;
                            zone4 = 30.4;
                            zone5 = 39.7;
                        }
                    } else {
                        if (this.watchType == 'TA3000') {
                            zone1 = 20;
                            zone2 = 25;
                            zone3 = 33;
                            zone4 = 37;
                            zone5 = 43;
                        } else {
                            zone1 = 13.6;
                            zone2 = 15.6;
                            zone3 = 18.3;
                            zone4 = 20.8;
                            zone5 = 24.1;
                        }
                    }
                } else {
                    if (gender == 1) {
                        if (this.watchType == 'TA3000') {
                            zone1 = 36;
                            zone2 = 41;
                            zone3 = 50;
                            zone4 = 57;
                            zone5 = 65;
                        } else {
                            zone1 = 32.1;
                            zone2 = 40.1;
                            zone3 = 48;
                            zone4 = 55.2;
                            zone5 = 66.3;
                        }
                    } else {
                        if (this.watchType == 'TA3000') {
                            zone1 = 29;
                            zone2 = 35;
                            zone3 = 43;
                            zone4 = 50;
                            zone5 = 57;
                        } else {
                            zone1 = 23.9;
                            zone2 = 30.5;
                            zone3 = 37.6;
                            zone4 = 44.7;
                            zone5 = 56;
                        }
                    }
                }
                return [zone1, zone2, zone3, zone4, zone5];
            }
        }
    }
</script>

<style scoped>

    #chart-box {
        height: 198px;
        width: 100%;
    }

    .legend-box {
        width: 100%;
        height: 56px;
        /*background-color: #20D38F;*/
        position: relative;
    }

    .legend-bar {
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }

    .legend-bar1 {
        background-color: var(--chart-color-3);
        left: 41px;
        top: 4px;
    }

    .legend-bar2 {
        background-color: var(--chart-color-15);
        left: 164px;
        top: 4px;
    }

    .legend-bar3 {
        background-color: var(--chart-color-5);
        left: 287px;
        top: 4px;
    }

    .legend-bar4 {
        background-color: var(--chart-color-1);
        left: 41px;
        top: 30px;
    }

    .legend-bar5 {
        background-color: var(--chart-color-8);
        left: 164px;
        top: 30px;
    }

    .legend-bar6 {
        background-color: var(--chart-color-10);
        left: 287px;
        top: 30px;
    }


    .legend-text {
        position: absolute;
        font-size: 13px;
        color: var(--text-color-2);
    }

    .legend-text1 {
        top: 0;
        left: 54px;
    }

    .legend-text2 {
        top: 0;
        left: 177px;
    }

    .legend-text3 {
        top: 0;
        left: 300px;
    }

    .legend-text4 {
        top: 26px;
        left: 54px;
    }

    .legend-text5 {
        top: 26px;
        left: 177px;
    }

    .legend-text6 {
        top: 26px;
        left: 300px;
    }

    .vo2max-box {
        width: 315px;
        background: var(--bg-color-1);
        border-radius: 13px 13px 13px 13px;
        margin: 15px auto;
        padding-bottom: 10px;
    }

    .vo2max-title {
        color: var(--text-color-1);
        margin-left: 19px;
        font-size: 15px;
        padding-top: 14px;
        margin-bottom: 10px;
    }

    .light-item {
        width: 291px;
        height: 30px;
        background: var(--bg-color-2);
        border-radius: 5px 5px 5px 5px;
        font-size: 13px;
        color: var(--text-color-2);
        margin: 0 auto;
        line-height: 30px;
    }

    .item-key {
        float: left;
        margin-left: 14px;
    }

    .item-value {
        float: right;
        margin-right: 14px;
    }

    .dark-item {
        width: 291px;
        height: 30px;
        border-radius: 5px 5px 5px 5px;
        font-size: 13px;
        color: var(--text-color-2);
        margin: 0 auto;
        line-height: 30px;
    }

    .time-box {
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/views/status/14vo2max.vue